import debounce from 'lodash/debounce';
import { useMemo } from 'react';

interface UseExecWithDebounceArgs{
    delay?: number;
}

export function useExecWithDebounce<TReturnValue>({ delay = 200 }: UseExecWithDebounceArgs = {}) {
    const execWithDebounce = useMemo(() => {
        return debounce((callback: () => (TReturnValue | Promise<TReturnValue>)) => {
            callback();
        }, delay);
    }, [ delay ]);

    return execWithDebounce;
}
